/**
 * Chatbot init function
 */
function loadAndExecuteScript (url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = url
    script.async = true
    script.onload = () => {
      console.log(`Script from ${url} has been loaded and executed successfully.`)
      resolve()
    }

    script.onerror = (error) => {
      console.error(`Failed to load script from ${url}:`, error)
      reject(error)
    }

    document.head.appendChild(script)
  })
}

/**
 * Launch chatbot
 */
const envIsProduction = true
const prodUrl = 'https://chatbot.d2l.arizona.edu/arizona/nosso/gradcollege/gradcollege001?lo=1'
const testUrl = 'https://test.chatbot.d2l.arizona.edu/arizona/nosso/gradcollege/gradcollege001?lo=1'
const sourceUrl = envIsProduction
  ? prodUrl
  : testUrl

loadAndExecuteScript(sourceUrl)
  .then(() => {
    console.log('Script execution completed.')
  })
  .catch((error) => console.error('Script execution failed:', error))

